import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Transition from "react-transition-group/Transition";

import styles from "./DropdownWrapper.css";

class DropdownWrapper extends Component {
  render() {
    let menuClass = styles.exited;
    let menuOpen = null;
    return (
      <Transition in={this.props.open} timeout={{ enter: 700, exit: 500 }}>
        {state => {
          switch (state) {
            case "entering":
              menuClass = styles.entering;
              menuOpen = null;
              break;
            case "entered":
              menuClass = styles.entered;
              menuOpen = styles.menuOpen;
              break;
            case "exiting":
              menuClass = styles.exiting;
              menuOpen = styles.menuOpen;
              break;
            case "exited":
              menuClass = styles.exited;
              menuOpen = null;
              break;
          }
          return (
            <div
              className={classNames(menuClass, menuOpen)}
              data-content-id={this.props.contentId}
            >
              <div
                className={
                  menuClass === styles.entering
                    ? styles.rollDown
                    : menuClass === styles.exiting
                    ? styles.rollUp
                    : null
                }
              />
              {this.props.children}
            </div>
          );
        }}
      </Transition>
    );
  }
}

export default DropdownWrapper;

DropdownWrapper.propTypes = {
  open: PropTypes.bool.isRequired,
  children: PropTypes.node,
  contentId: PropTypes.string.isRequired,
};
